(function(){
var R = document.querySelector(".atb2"); if(!R) return;
var D = window.__ATBW__ || {b:[],e:[],g:[],n:[],f:[]};
var bar   = R.querySelector(".bar"),
wall  = R.querySelector(".wall"),
tiles = [].slice.call(wall.querySelectorAll(".bt")),
ltrs  = [].slice.call(wall.querySelectorAll(".ltr")),
q     = R.querySelector("#atbq"),
clr   = R.querySelector(".clr"),
sug   = R.querySelector(".sug"),
state = R.querySelector(".state"),
az    = R.querySelector(".az"),
jz    = [].slice.call(R.querySelectorAll(".jz"));
var open = null, sheet = null;
(D.g || []).forEach(function(v, i){
var im = tiles[i] && tiles[i].querySelector("img");
if(!im || !v) return;
im.style.setProperty("--lh", v[0]);
im.style.setProperty("--lx", v[1]);
im.style.setProperty("--ly", v[2]);
});
function esc(s){ return String(s).replace(/&(?!#?\w+;)/g,"&amp;")
.replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }
function plural(n,w){ return n.toLocaleString()+" "+w+(n===1?"":"s"); }
function shows(t){ return t.style.display !== "none"; }
function has(list,v){ return (","+list+",").indexOf(","+v+",") > -1; }
function mark(s,term){
var i = s.toLowerCase().indexOf(term);
if(i < 0 || !term) return esc(s);
return esc(s.slice(0,i))+"<mark>"+esc(s.slice(i,i+term.length))+"</mark>"+esc(s.slice(i+term.length));
}
R.addEventListener("error", function(e){
var t = e.target;
if(t.tagName === "IMG" && t.parentNode && t.parentNode.className === "mk"){
t.parentNode.parentNode.className += " nolg"; t.remove();
}
}, true);
var IDX = D.e.map(function(e){
return (D.b[e[0]]+" "+e[1]+" "+e[3]+" "+(e[6]||"")).replace(/&amp;/g,"&").toLowerCase();
});
function close(){
if(sheet){ sheet.remove(); sheet = null; }
var prev = wall.querySelector(".bt.on");
if(prev) prev.className = prev.className.replace(" on","");
open = null;
}
function entryCard(e, i){
var chipsHtml = e[3].split("|").map(function(c, k){
var kind = e[4] === "m" ? " man" : (e[4] === "c" ? " cap" : " own");
return '<span class="wc'+(k === 0 ? kind : "")+'">'+esc(c)+'</span>';
}).join("");
return '<a class="st" style="animation-delay:'+Math.min(i,10)*22+'ms" href="'+e[2]+'">'+
'<span class="sn">'+esc(e[1])+'</span>'+
'<span class="wl">'+chipsHtml+'</span></a>';
}
function openSheet(tile, only){
var bx = +tile.getAttribute("data-i");
if(open === bx && !only){ close(); return; }
close();
open = bx; tile.className += " on";
var rows = [];
for(var i=0;i<D.e.length;i++){
var e = D.e[i];
if(e[0] !== bx) continue;
if(only && only.indexOf(i) < 0) continue;
rows.push(e);
}
sheet = document.createElement("div");
sheet.className = "sheet";
sheet.innerHTML = '<div class="sh-hd"><h3>'+esc(D.b[bx])+'</h3><span class="sc">'+
rows.length+(rows.length === 1 ? " warranty entry" : " warranty entries")+'</span>'+
'<button class="x" type="button" aria-label="Close">&times;</button></div>'+
'<div class="sets">'+rows.map(entryCard).join("")+'</div>'+
'<p class="sh-ft">Coverage terms are the manufacturer’s own. '+
'<a href="/pages/contact-us">Ask us if you cannot find yours</a></p>';
sheet.querySelector(".x").addEventListener("click", close);
var vis = tiles.filter(shows), top = tile.offsetTop, last = tile;
for(var j=0;j<vis.length;j++) if(vis[j].offsetTop === top) last = vis[j];
last.parentNode.insertBefore(sheet, last.nextSibling);
var box = sheet.getBoundingClientRect();
if(box.bottom > window.innerHeight)
window.scrollTo({top: box.top + window.pageYOffset - 128, behavior:"smooth"});
}
wall.addEventListener("click", function(e){
var t = e.target.closest ? e.target.closest(".bt") : null;
if(!t) return;
e.preventDefault();
openSheet(t);
});
document.addEventListener("keydown", function(e){
if(e.key !== "Escape") return;
if(!sug.hidden){ hideSug(); return; }
close();
});
function paint(hits){
close();
var shown = 0, term = q.value.trim();
tiles.forEach(function(t){
var ok = !hits || !!hits[+t.getAttribute("data-i")];
t.style.display = ok ? "" : "none";
var b = t.querySelector(".hit"); if(b) b.remove();
if(ok && hits){
var s = document.createElement("span");
s.className = "hit"; s.textContent = hits[+t.getAttribute("data-i")].length;
t.appendChild(s);
}
if(ok) shown++;
});
ltrs.forEach(function(l){ l.style.display = term ? "none" : ""; });
az.hidden = !!term;
var v = R.querySelector(".void");
if(!shown && !v){
v = document.createElement("div");
v.className = "void";
v.innerHTML = '<b>No warranty document under that</b><p>Try a shorter spelling, or the '+
'series name on its own. Send us the model number and we will track the right '+
'document down for you.</p>';
wall.appendChild(v);
} else if(shown && v){ v.remove(); }
state.textContent = term ? plural(shown,"brand")+' matching "'+term+'"' : "";
}
document.addEventListener("click", function(e){
if(!bar.contains(e.target)) bar.className = bar.className.replace(" open","");
});
var pick = -1, rows = [];
function hideSug(){ sug.hidden = true; pick = -1; }
function drawSug(list, term){
rows = list;
if(!list.length){ hideSug(); return; }
sug.innerHTML = '<p class="hd">Jump straight to</p>' + list.map(function(e, i){
return '<button class="sg" type="button" data-n="'+i+'" role="option" aria-selected="false">'+
'<span class="tx"><span class="t">'+mark(e[1].replace(/&amp;/g,"&"), term)+'</span>'+
'<span class="m">'+esc(D.b[e[0]])+'</span></span>'+
'<span class="r">'+esc(e[3].split("|")[0])+'</span></button>';
}).join("");
sug.hidden = false;
}
function move(d){
if(sug.hidden || !rows.length) return;
pick = (pick + d + rows.length) % rows.length;
[].slice.call(sug.querySelectorAll(".sg")).forEach(function(el, i){
el.setAttribute("aria-selected", String(i === pick));
if(i === pick) el.scrollIntoView({block:"nearest"});
});
}
sug.addEventListener("click", function(e){
var b = e.target.closest ? e.target.closest(".sg") : null;
if(b && rows[+b.getAttribute("data-n")]) location.href = rows[+b.getAttribute("data-n")][2];
});
q.addEventListener("keydown", function(e){
if(e.key === "ArrowDown"){ e.preventDefault(); move(1); }
else if(e.key === "ArrowUp"){ e.preventDefault(); move(-1); }
else if(e.key === "Enter" && pick > -1 && rows[pick]){ e.preventDefault(); location.href = rows[pick][2]; }
});
q.addEventListener("blur", function(){ setTimeout(hideSug, 160); });
function run(){
var term = q.value.trim().toLowerCase();
clr.hidden = !term;
if(!term){ hideSug(); paint(null); return; }
var hits = {}, top = [];
for(var i=0;i<D.e.length;i++){
var e = D.e[i];
if(IDX[i].indexOf(term) < 0) continue;
(hits[e[0]] = hits[e[0]] || []).push(i);
if(top.length < 8) top.push(e);
}
for(var b=0;b<D.b.length;b++)
if(!hits[b] && D.b[b].toLowerCase().indexOf(term) > -1){
hits[b] = [];
for(var k=0;k<D.e.length;k++)
if(D.e[k][0] === b){
hits[b].push(k);
if(top.length < 8) top.push(D.e[k]);
}
}
drawSug(top, term);
paint(hits);
var keys = Object.keys(hits);
if(keys.length === 1){
var only = tiles.filter(function(x){ return x.getAttribute("data-i") === keys[0]; })[0];
if(only) openSheet(only, hits[keys[0]]);
}
}
var tmr;
q.addEventListener("input", function(){ clearTimeout(tmr); tmr = setTimeout(run, 110); });
clr.addEventListener("click", function(){ q.value = ""; run(); q.focus(); });
function letterTop(L){
for(var i=0;i<ltrs.length;i++)
if(ltrs[i].getAttribute("data-l") === L)
return ltrs[i].getBoundingClientRect().top + window.pageYOffset;
return null;
}
az.addEventListener("click", function(e){
var b = e.target.closest ? e.target.closest(".jz") : null;
if(!b || /\boff\b/.test(b.className)) return;
var top = letterTop(b.getAttribute("data-l"));
if(top == null) return;
close();
var lands = R.querySelector(".seek").offsetHeight + az.offsetHeight + 26;
window.scrollTo({top: Math.max(0, top - lands - 10), behavior:"smooth"});
});
function markLetter(){
if(az.hidden) return;
var edge = bar.getBoundingClientRect().bottom + 24, cur = null;
for(var i=0;i<ltrs.length;i++){
if(ltrs[i].getBoundingClientRect().top > edge) break;
cur = ltrs[i].getAttribute("data-l");
}
jz.forEach(function(b){
var on = b.getAttribute("data-l") === cur;
if(on !== /\bhere\b/.test(b.className))
b.className = on ? b.className+" here" : b.className.replace(" here","");
});
}
var head = R.querySelector(".top"), ticking = false;
function onScroll(){
var stuck = window.pageYOffset > head.offsetHeight - 6;
if(stuck !== /\bstuck\b/.test(bar.className))
bar.className = stuck ? bar.className+" stuck"
: bar.className.replace(" stuck","").replace(" open","");
markLetter();
}
window.addEventListener("scroll", function(){
if(ticking) return;
ticking = true;
requestAnimationFrame(function(){ ticking = false; onScroll(); });
}, {passive:true});
onScroll();
})();